module.exports = coreApis.componentApis.video.playerAgent;